import { SVGProps } from 'react';

const SvgExit = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M12 1a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1ZM6.337 5.933a1 1 0 0 1 0 1.414 8 8 0 1 0 11.316 0 1 1 0 1 1 1.414-1.414 10 10 0 1 1-14.144 0 1 1 0 0 1 1.414 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgExit;
